export var EmployeeRolesCodes;
(function (EmployeeRolesCodes) {
    EmployeeRolesCodes["OWNER"] = "employee::owner";
    EmployeeRolesCodes["ADMIN"] = "employee::admin";
    EmployeeRolesCodes["DEFAULT"] = "employee";
})(EmployeeRolesCodes || (EmployeeRolesCodes = {}));
export var EmployeeRolesDescription;
(function (EmployeeRolesDescription) {
    EmployeeRolesDescription["OWNER"] = "Owner";
    EmployeeRolesDescription["ADMIN"] = "Admin";
    EmployeeRolesDescription["DEFAULT"] = "Employee";
})(EmployeeRolesDescription || (EmployeeRolesDescription = {}));
